import { createSelector } from '@reduxjs/toolkit';

import { tutorialsSelector } from '@lootboy/lib/slices/tutorials';

import { ITutorial } from '~/interfaces/ITutorial';

import { getTutorialPaths } from '../../utilities/tutorials';

export const tutorialSMappedByPathSelector = createSelector(
  tutorialsSelector,
  ({ items }) =>
    items.reduce(
      (
        acc: {
          [key: string]: string;
        },
        tutorial: ITutorial,
      ) => {
        const { route, path } = getTutorialPaths(tutorial) || {};
        if (route && path) {
          acc[route] = path;
        }
        return acc;
      },
      {},
    ),
);
